import {Component, OnInit} from '@angular/core';
import {Subject} from '../../../node_modules/rxjs';
import {HttpClient} from '@angular/common/http';
import {debounceTime} from 'rxjs/operators';
import { Router } from '@angular/router';
import {APP_DATE_FORMAT,CommonUtility, DateUtility, ServerConstantsService} from '../shared';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'angular2-notifications';
import {ReferenceTableService} from '../reference-table.service';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  private _danger = new Subject<string>();
  errorMessage: string;
  private _success = new Subject<string>();
  successMessage: string;
  ServerConstants: any;
  userActionNotificationsMap: any;

  APP_DATE_FORMAT = APP_DATE_FORMAT;
  refData: any;


  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private dateUtil: DateUtility,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private router: Router,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.router.navigate(['/admin/announcementsSummary']);
  }

  ngOnInit() {

    /* error message */
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this.errorMessage = null);

    /* Success message*/
    this._success.subscribe((message) => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);

    /* Read reference table data */
    this.getRefData();

  }

  getRefData(){
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });
  }

  parseRefTableData(myData) {
    if (myData !== undefined && myData.englishDropDown) {
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.component.ts